"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrientation = void 0;
const react_1 = require("react");
const getOrientation = () => {
    if (typeof window === 'undefined')
        return 'landscape'; // default fallback
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
};
const useOrientation = () => {
    const [orientation, setOrientation] = (0, react_1.useState)('portrait');
    (0, react_1.useEffect)(() => {
        if (typeof window === 'undefined')
            return;
        const updateOrientation = () => {
            const newOrientation = getOrientation();
            setOrientation(newOrientation);
        };
        updateOrientation();
        window.addEventListener('resize', updateOrientation);
        return () => window.removeEventListener('resize', updateOrientation);
    }, []);
    return orientation;
};
exports.useOrientation = useOrientation;
